'use strict';
import { j as e } from "../../external/react/jsx-runtime.js";
import s from "../../external/classnames/index.js";
import r from "./divider.module.scss.js";
const d = ({ margin: i = !0 }) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: s(
      r.divider,
      i ? r["divider--margin"] : ""
    ),
    "aria-hidden": !0
  }
);
export {
  d as default
};
